export default "__VITE_ASSET__Bp43ksQ4__"